import { render, staticRenderFns } from "./inputScore.vue?vue&type=template&id=77c83c80&"
import script from "./inputScore.vue?vue&type=script&lang=js&"
export * from "./inputScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports